export const validOrgnrPattern = /^\d{9}$/;
export const validFnrPattern = /^\d{11}$/;
export const validRegistrationNumberPattern = /^\d{5,6}$|^[a-zA-Z]\d{1,6}$|^[a-zA-Z]{2}\d{4,5}$/;
